import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import DatatablesActionTypes from '../datatables/DatatablesActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    title: null,
    message: null,
});

class DialogStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        let type = action.type;

        if (type === ActionTypes.LOGOUT) // || type === ActionTypes.UPDATE_TOKEN_FAILED)
            return state.clear();

        // TODO: UPDATE_TOKEN_FAILED deve mostrar erro amigável para usuário

        switch (type) {
            case ActionTypes.OPEN_DIALOG:
                return state.set('title', action.title).set('message', action.message);

            case ActionTypes.CLOSE_DIALOG:
                return state.set('title', null).set('message', null);
        }

        // Falhas no insert, update e delete do datatables são
        // gerenciados pelo próprio datatables
        if (type === DatatablesActionTypes.DATATABLE_CREATE_FAILED ||
            type === DatatablesActionTypes.DATATABLE_EDIT_FAILED ||
            type === DatatablesActionTypes.DATATABLE_REMOVE_FAILED)
            return state;

        let index = type.indexOf('_FAILED');

        if (index > 0 && (type.length === index + 7)) {
            return state.set('title', 'Ocorreu um erro')
              .set('message', action.error.errorDescription);
        }

        return state;
    }
}

export default new DialogStore();



// WEBPACK FOOTER //
// src/stores/DialogStore.js